import React, { useCallback } from "react";
import { CareRecipientSortCondition } from "../../../../../domain/care_recipient/CareRecipientWithDataSyncInformation";
import { useAppDispatch } from "../../../../../state/store";
import { sortAction } from "../../../../../state/usecase/admin/care_recipient/actions";

export const CareRecipientsTableHead = React.memo(function CareRecipientTableHead() {
    const dispatch = useAppDispatch();

    const handleSortClick = useCallback((sortCondition: CareRecipientSortCondition, asc: boolean) => () => {
        dispatch(
            sortAction({ sortCondition: sortCondition, asc: asc })
        );
    }, [dispatch]);

    return (
        <thead>
            <tr className={"header"}>
                <th className={"house"}>ハウスID</th>
                <th className={"name"}>氏名</th>
                <th className={"data_sync"}>
                    <div>データ連携開始日時</div>
                    <div>平均値期間設定</div>
                    <div>データ連携終了日時</div>
                </th>
                <th className={"control"} />
            </tr>
            <tr className={"header"}>
                <th className={"house"}>
                    <div className={"sort_button_area"}>
                        <button className={"sort_button"} type="button" onClick={handleSortClick(CareRecipientSortCondition.HOUSE_ID, true)}>▲</button>
                        <button className={"sort_button"} type="button" onClick={handleSortClick(CareRecipientSortCondition.HOUSE_ID, false)}>▼</button>
                    </div>
                </th>
                <th className={"name"}>
                    <div className={"sort_button_area"}>
                        <button className={"sort_button"} type="button" onClick={handleSortClick(CareRecipientSortCondition.CARE_RECIPIENT_NAME, true)}>▲</button>
                        <button className={"sort_button"} type="button" onClick={handleSortClick(CareRecipientSortCondition.CARE_RECIPIENT_NAME, false)}>▼</button>
                    </div>
                </th>
                <th className={"data_sync"}>
                    <div className={"sort_button_area"}>
                        <button className={"sort_button"} type="button" onClick={handleSortClick(CareRecipientSortCondition.DATA_SYNC_START_TIME, true)}>▲</button>
                        <button className={"sort_button"} type="button" onClick={handleSortClick(CareRecipientSortCondition.DATA_SYNC_START_TIME, false)}>▼</button>
                    </div>
                </th>
                <th />
            </tr>
        </thead>
    );
});